import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import ReactDateTime from 'react-datetime';
import moment, { isMoment } from 'moment';
import { langType, withLang } from '../../../../i18n';
import { validateApiDateStr } from '../../../../util';

class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.onDateChange = this.onDateChange.bind(this);
  }

  onDateChange(newDate) {
    const { onChange } = this.props;

    if (!newDate) {
      onChange(null);
      return;
    } if (!isMoment(newDate)) {
      return;
    }

    onChange(this.parseDate(newDate));
  }

  parseDate(date) {
    const { dayStart, dayEnd } = this.props;
    if (dayStart) {
      return date.startOf('day');
    }
    if (dayEnd) {
      return date.endOf('day');
    }
    return date;
  }

  render() {
    const { lang, placeholder, value } = this.props;

    return (
      <ReactDateTime
        value={validateApiDateStr(value) && moment(value)}
        timeFormat={false}
        locale={lang}
        onChange={this.onDateChange}
        inputProps={{ placeholder }}
      />
    );
  }
}

DatePicker.propTypes = {
  onChange: func.isRequired,
  dayStart: bool,
  dayEnd: bool,
  placeholder: string,
  value: string,
  ...langType
};

DatePicker.defaultProps = {
  dayStart: false,
  dayEnd: false,
  placeholder: '',
  value: ''
};

export default withLang(DatePicker);
